import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'embryo-HeaderCart',
  templateUrl: './HeaderCart.component.html',
  styleUrls: ['./HeaderCart.component.scss'],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class HeaderCartComponent implements OnInit, OnChanges {

   @Input() cartProducts : any;
   @Input() count        : any;
   @Input() currency     : string;
   @Input() exchangeMX     : number;

   mobWidth : any;
   mobScreenSize : number = 767;

   @Output() removeProductData : EventEmitter<any> = new EventEmitter();  

   hiddenBadge = true;

   constructor(public translate:TranslateService) {
      this.mobWidth = window.screen.width;
      console.log("HeaderCart - constructor");
   }

   ngOnInit() {
      console.log("HeaderCart - oninit");
   }

   ngOnChanges() {
      console.log("HeaderCart - onchanges");
      if(this.count && this.count != 0) {
         this.hiddenBadge = false;
      } else {
         this.hiddenBadge = true;
      }
   }

   public confirmationPopup(product:any) {
      console.log("HeaderCart - confirmationPopup");
      this.removeProductData.emit(product);
   }

   public calculatePrice(product) {
      console.log("HeaderCart - calculate price :" + JSON.stringify(product));
      let total = null;
      if (product.quantity>0) {
          total = product.discount_price*product.quantity; 
      }
      return total;
     
   }


}
